import { Col, Row } from 'reactstrap';

export const SkeletonUpdateInvitation = () => {
	const skeletonStyle: React.CSSProperties = {
		background: '#f2f2f4',
		borderRadius: '4px',
		height: '38px',
		width: '100%',
		marginBottom: '16px',
		animation: 'pulse 1.5s infinite'
	};

	const skeletonLabelStyle: React.CSSProperties = {
		background: '#f2f2f4',
		borderRadius: '4px',
		height: '18px',
		width: '40%',
		marginBottom: '8px',
		animation: 'pulse 1.5s infinite'
	};

	// Add keyframes for pulse animation
	const styleSheet = document.createElement('style');
	styleSheet.type = 'text/css';
	styleSheet.innerText = `
	@keyframes pulse {
		0% { opacity: 1; }
		50% { opacity: 0.4; }
		100% { opacity: 1; }
	}
	`;
	document.head.appendChild(styleSheet);

	return (
		<Row>
			<Col md={8} xxl={6}>
				<div style={skeletonLabelStyle}></div>
				<div style={skeletonStyle}></div>
				<div style={skeletonLabelStyle}></div>
				<div style={skeletonStyle}></div>
				<div style={skeletonLabelStyle}></div>
				<div style={skeletonStyle}></div>
				<div style={skeletonLabelStyle}></div>
				<div style={skeletonStyle}></div>
				{/* Add more skeletons as needed */}
			</Col>
		</Row>
	);
};
